import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_CARD_OPTION_FRAGMENT } from '../components/NarrativeCardOption';
import { NARRATIVE_CARD_COMPANY_FRAGMENT } from '../components/NarrativeCardOption/NarrativeCardOption';

const QUERY = gql(
  `
  query NarrativeFairValueModalGetNarrativeValuationOptions($companyId: ID!) {
    company(ref: $companyId) {
      tickerSymbol
      ...NarrativeCardOptionCompanyFields
      valuationOptions {
        ...NarrativeCardOptionValuationOptionFields
      }
    }
  }
`,
  [NARRATIVE_CARD_OPTION_FRAGMENT, NARRATIVE_CARD_COMPANY_FRAGMENT]
);

export const useNarrativeValuationOptions = makeGqlSuspenseQuery(QUERY);
